import { nsSimCard } from '@/app/i18n/namespaces';

export default {
    DETAILS: {
        key: 'details',
        enableSorting: false
    },
    UUID: {
        key: 'uuid',
        enableSorting: false
    },
    ORGANIZATION: {
        key: 'organization',
        type: 'text',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.organization',
        placeholder: 'sim_pools.filter.placeholder.organization',
        filter: 'input',
        enableSorting: true
    },
    ORGANIZATION_UUID: {
        key: 'organizationUuid',
        type: 'text'
    },
    TARIFF_DATA: {
        key: 'tariffData',
        type: 'number',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.tariff_data',
        enableSorting: true
    },
    TARIFF_DATA_UNIT: {
        key: 'tariff-data-unit',
        type: 'text'
    },
    PROVIDER: {
        key: 'simProvider',
        altKey: 'provider',
        type: 'text',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.sim_provider',
        placeholder: 'sim_pools.filter.placeholder.provider',
        filter: 'input',
        enableSorting: true
    },
    ACTIVATED_SIMS: {
        key: 'activatedSims',
        type: 'number',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.activated_sims',
        tooltip: 'sim_pools.tooltip.activated_sims',
        enableSorting: true
    },
    MONTH_YEAR: {
        key: 'monthYear'
    },
    TOTAL_ACTIVATED_SIMS: {
        key: 'totalActivatedSims'
    },
    DATA_CONSUMPTION: {
        key: 'dataConsumption',
        type: 'number',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.monthly_consumption',
        tooltip: 'sim_pools.tooltip.monthly_consumption',
        enableSorting: true
    },
    TOTAL_DATA: {
        key: 'totalData',
        type: 'number',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.total_data',
        tooltip: 'sim_pools.tooltip.total_data',
        enableSorting: true
    },
    CONSUMPTION_PERCENTAGE: {
        key: 'consumptionPercentage',
        type: 'number',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.consumption_percentage',
        enableSorting: true
    },
    DATA_USAGE: {
        key: 'dataUsage',
        type: 'chart',
        entity: 'keys.data_usage',
        namespace: nsSimCard,
        placeholder: 'filter.placeholder.data_usage',
        filter: 'number',
        enableSorting: true
    },
    SIM_OFFER: {
        key: 'simOffer',
        type: 'object',
        namespace: nsSimCard,
        entity: 'sim_pools.keys.sim_offer',
        DATA: {
            parentKeys: ['simOffer'],
            key: 'data',
            type: 'number',
            namespace: nsSimCard,
            entity: 'sim_pools.keys.sim_offer.data'
        },
        DATA_UNIT: {
            parentKeys: ['simOffer'],
            key: 'dataUnit',
            type: 'text',
            namespace: nsSimCard,
            entity: 'sim_pools.keys.sim_offer.data_unit'
        }
    }

};